import React from "react";

interface FooterProps {
  onTermsClick: () => void;
  hiddenOnMobile?: boolean;
}

const commonButtonStyle: React.CSSProperties = {
  background: "none",
  border: "none",
  color: "var(--accent-color, #6c5ce7)",
  textDecoration: "underline",
  cursor: "pointer",
  padding: 0,
  font: "inherit",
};

const Footer: React.FC<FooterProps> = ({ onTermsClick, hiddenOnMobile }) => (
  <footer
    className={`footer-text${hiddenOnMobile ? ' input-hidden-mobile' : ''}`}
    style={{
      width: "100%",
      textAlign: "center",
      fontSize: "12px",
      padding: "16px",
      display: "flex",
      flexDirection: "column",
      gap: "8px"
    }}
  >
    <div>
      <span className="full-disclaimer">
        Durch das Senden einer Nachricht stimmen Sie unseren{" "}
        <button onClick={onTermsClick} style={commonButtonStyle}>
          Nutzungsbedingungen
        </button>{" "}
        zu.
      </span>
      <span className="short-disclaimer">
        Durch Senden stimmen Sie den{" "}
        <button onClick={onTermsClick} style={commonButtonStyle}>
          Nutzungsbedingungen
        </button>{" "}
        zu.
      </span>
    </div>
    <div className="disclaimer-extra" style={{ fontSize: "10px", color: "var(--text-muted, #a0aec0)", marginTop: "4px" }}>
      Diese Plattform ist ein unabhängiges Projekt und steht in keiner offiziellen Verbindung zur Allgemeinen Anthroposophischen Gesellschaft oder zum Rudolf Steiner Verlag.
    </div>
  </footer>
);

export default Footer;
